export default __webpack_public_path__ + "b8b4cc9d2e4572af8668abb43b9efe08.png";